import { GetCandidateProfileForCandidateQuery } from '__generated__/graphql'
import { Dispatch, SetStateAction } from 'react'

export interface FormComponentProps {
    loading: boolean
    data: GetCandidateProfileForCandidateQuery
    refetch: () => Promise<void>
    edit: boolean
    setEdit: (nextState: PROFILE_SECTIONS | null) => void
    closeEditWithoutModal: () => void
    setUnsavedChangesExist: Dispatch<SetStateAction<boolean>>
}

export enum PROFILE_SECTIONS {
    BIO = 'bio',
    ABOUT_ME = 'aboutMe',
    EDUCATION = 'education',
    WORK_EXPERIENCE = 'workExperience',
    ADDITIONAL_INFORMATION = 'additionalInformation',
    REFERENCES = 'references',
    TEST_SCORES = 'testScores',
}
